export const NAV = [
  { id: "brands", label: "Brands" },
  { id: "manifesto", label: "Manifesto" },
  { id: "services", label: "Services" },
  { id: "why-india", label: "Why Remote" },
  { id: "process", label: "Process" },
  { id: "calculator", label: "Calculator" },
  { id: "contact", label: "Contact" },
];

export const BRANDS = [
  {
    id: "artwork360",
    name: "Artwork 360",
    kicker: "Brand 01 — Creative & Order Operations",
    tagline: "360° Solutions For Promotional Excellence",
    domain: "artwork-360.com",
    url: "https://artwork-360.com",
    accent: "#5271FF",
    image: "https://images.unsplash.com/photo-1621111848501-8d3634f82336?q=80&w=1600&auto=format&fit=crop",
    alt: "Designer working on brand artwork at a studio desk",
    description:
      "End-to-end creative and order management for US promotional-products businesses. From logos and marketing collateral to production-ready artwork and vendor coordination, one team owns the brief through to delivery.",
    services: ["Graphic Design & Branding", "Promotional Product Artwork", "Marketing Collateral", "Order Management", "Fast Revisions"],
  },
  {
    id: "medlyn360",
    name: "Medlyn 360",
    kicker: "Brand 02 — Live Human Medical Scribing",
    tagline: "Spend more time with patients. We'll handle the documentation.",
    domain: "medlyn360.com",
    url: "https://medlyn360.com",
    accent: "#4FC3E8",
    image: "https://images.unsplash.com/photo-1758691463203-cce9d415b2b5?q=80&w=1600&auto=format&fit=crop",
    alt: "Physician reviewing a chart on a tablet",
    description:
      "Virtual live human medical scribes documenting patient encounters in real time, directly inside your EHR — plus dedicated virtual assistants who handle scheduling, patient calls, insurance verification and prior authorisations for your practice. HIPAA compliant, BAA supported, no software to install.",
    services: ["Real-time EHR Documentation", "Virtual Medical Assistants", "HIPAA Compliant · BAA", "Works with Epic, Cerner, athena & more", "Coding Support", "Reduced Physician Burnout"],
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Human at the core.",
    body: "Software drafts; people decide. Every Malansh deliverable is produced by a trained specialist who is accountable for it — whether it's a HIPAA-bound clinical note or a print-ready proof.",
  },
  {
    n: "02",
    title: "360° means end to end.",
    body: "We don't hand off half the job. From brief to delivery, from door-open to chart-closed, one team owns the outcome so you never juggle vendors.",
  },
  {
    n: "03",
    title: "Your night is our day.",
    body: "A 9.5 to 12.5 hour lead on US time means work submitted at close of business is reviewed, produced and waiting for you by morning.",
  },
  {
    n: "04",
    title: "Partners, not vendors.",
    body: "We measure ourselves on your retention, not our invoices. Long-term relationships are the only metric that compounds.",
  },
];

export const SERVICES = [
  {
    icon: "PenTool",
    brand: "Artwork 360",
    title: "Creative Production",
    body: "Logos, brand identity, marketing materials and promotional product artwork — unique, brand-specific and print-ready.",
    span: "lg:col-span-7",
    accent: "#5271FF",
  },
  {
    icon: "Package",
    brand: "Artwork 360",
    title: "Order Management",
    body: "Concept to execution. We coordinate vendors, track orders and keep delivery on schedule so you don't handle logistics.",
    span: "lg:col-span-5",
    accent: "#5271FF",
  },
  {
    icon: "Stethoscope",
    brand: "Medlyn 360",
    title: "Live Medical Scribing",
    body: "A trained scribe joins each encounter over an encrypted channel and charts history, exam, assessment and plan in real time.",
    span: "lg:col-span-4",
    accent: "#4FC3E8",
  },
  {
    icon: "Headset",
    brand: "Medlyn 360",
    title: "Virtual Assistant for Medical Practitioners",
    body: "A dedicated remote assistant for your practice: appointment scheduling, patient calls and reminders, insurance verification, prior authorisations, referrals and inbox management — HIPAA-conscious and in your EHR.",
    span: "lg:col-span-4",
    accent: "#4FC3E8",
  },
  {
    icon: "FileText",
    brand: "Medlyn 360",
    title: "Documentation & Coding Support",
    body: "Structured notes ready for sign-off at the end of the visit, supporting cleaner coding and faster billing cycles.",
    span: "lg:col-span-4",
    accent: "#4FC3E8",
  },
  {
    icon: "Users",
    brand: "Malansh",
    title: "Dedicated Teams",
    body: "Scale from a few hours a week to full-time, multi-seat coverage with a single accountable team lead.",
    span: "lg:col-span-4",
    accent: "#2A3192",
  },
  {
    icon: "ShieldCheck",
    brand: "Malansh",
    title: "Quality Framework",
    body: "Layered QA, documented SOPs and US-workflow training baked into every engagement across both brands.",
    span: "lg:col-span-4",
    accent: "#2A3192",
  },
  {
    icon: "Clock",
    brand: "Malansh",
    title: "US-hours Coverage",
    body: "Synchronous support during your business day and overnight production for everything else.",
    span: "lg:col-span-4",
    accent: "#2A3192",
  },
];

export const STATS = [
  { value: 2, suffix: "", label: "Specialist brands, one standard" },
  { value: 360, suffix: "°", label: "End-to-end ownership of outcomes" },
  { value: 12.5, suffix: "h", label: "Head start on US time zones" },
  { value: 100, suffix: "%", label: "Human-produced, human-reviewed work" },
];

export const WHY_INDIA = [
  { n: "01", title: "Hiring you don't have to run", body: "We recruit, vet and train so you don't. A specialist is typically staffed on your account in 4–8 weeks — trained on your workflows before day one, with no recruiter fee." },
  { n: "02", title: "Senior talent at a fraction of the cost", body: "Mumbai's deep pool of English-fluent design, clinical and operations professionals means you get experienced people — typically at 40–60% less than a US hire, all-in." },
  { n: "03", title: "Your end of day is our start", body: "Mumbai runs 9.5–12.5 hours ahead of the US. Work handed off at 5pm is produced overnight and waiting for you by morning — and live coverage during your clinic hours is standard." },
  { n: "04", title: "Scale up or down without the risk", body: "No payroll, benefits, office space or severance. Add a seat when volume grows, pause when it dips. Outsourcing turns a fixed cost into a flexible one." },
  { n: "05", title: "Keep your team on the work that matters", body: "Physicians see patients; designers pitch clients. Documentation, artwork production and order chasing move to us so your people stay on revenue." },
  { n: "06", title: "One accountable partner, not a freelancer", body: "Managed teams with a lead, layered QA, documented SOPs and HIPAA-conscious workflows. You get continuity and backup cover — not a single point of failure." },
];

export const COMPARE = {
  cols: ["Hiring locally", "Remote team with Malansh"],
  rows: [
    ["Time to fill a seat", "6–12 weeks, plus onboarding you run", "4–8 weeks, trained on your workflow before day one"],
    ["All-in cost per specialist", "Salary + benefits + office + recruiter", "One predictable monthly fee"],
    ["Coverage", "Business hours only", "US hours live + overnight production"],
    ["Scaling", "Hire, train, or lay off", "Add or pause seats any month"],
    ["Backup when someone is out", "Work stops", "Trained cover from the same team"],
    ["Management overhead", "Yours", "Ours — a dedicated team lead"],
  ],
};

export const PROCESS = [
  { n: "01", title: "Discovery call", time: "Day 1", body: "A 30-minute conversation about your brand, volumes, tools (EHR, design stack, order system) and what a great outcome looks like." },
  { n: "02", title: "Scope & proposal", time: "Within 1 week", body: "A written plan: roles, coverage hours, QA framework, security requirements and one predictable monthly fee per seat." },
  { n: "03", title: "Recruit, vet & train", time: "4–8 weeks", body: "We shortlist, test and interview. You meet the finalists. Your specialist is then trained on your exact workflows and SOPs before they touch live work." },
  { n: "04", title: "Go live, with a lead", time: "Ongoing", body: "Your team starts under a dedicated Malansh team lead, with layered QA, weekly reporting and trained backup cover from the same pool." },
];

export const CALC_ROLES = [
  { id: "csr", label: "Customer service / order coordinator", usCost: 52000, hireWeeks: "4–8 weeks" },
  { id: "scribe", label: "Medical scribe (live, virtual)", usCost: 48000, hireWeeks: "4–8 weeks" },
  { id: "va", label: "Virtual assistant for a medical practice", usCost: 45000, hireWeeks: "4–8 weeks" },
  { id: "designer", label: "Graphic / production designer", usCost: 68000, hireWeeks: "4–8 weeks" },
];

export const LOGO_KIT = [
  { file: "malansh-logo-horizontal-light", title: "Horizontal · for light backgrounds", note: "Primary lockup. Indigo wordmark, transparent background.", bg: "light" },
  { file: "malansh-logo-horizontal-dark", title: "Horizontal · for dark backgrounds", note: "White wordmark, transparent background.", bg: "dark" },
  { file: "malansh-logo-stacked-light", title: "Stacked · for light backgrounds", note: "Square-ish lockup for social avatars and slide covers.", bg: "light" },
  { file: "malansh-logo-stacked-dark", title: "Stacked · for dark backgrounds", note: "White stacked lockup, transparent background.", bg: "dark" },
  { file: "malansh-mark-indigo", title: "Mark only · indigo", note: "Favicon, app icon, watermark.", bg: "light" },
  { file: "malansh-mark-white", title: "Mark only · white", note: "Use on navy, indigo or photography.", bg: "dark" },
  { file: "malansh-app-icon", title: "App icon / favicon tile", note: "Navy rounded tile with the white mark — used as the browser tab icon and home-screen icon.", bg: "light" },
  { file: "malansh-social-preview", title: "Social preview card (1200×630)", note: "Shown when the website link is shared on LinkedIn, WhatsApp, Slack or X.", bg: "light", noSvg: true },
  { file: "malansh-logo-horizontal-on-white", title: "Email signature · on white", note: "Flattened PNG with white background (600px signature version included).", bg: "light", signature: true },
  { file: "malansh-logo-horizontal-on-navy", title: "Email signature · on navy", note: "Flattened PNG with navy background (600px signature version included).", bg: "dark", signature: true },
];

export const COMPANY = {
  name: "Malansh Solutions Private Limited",
  address: "Shop No. 8, Bldg No. 2, Samata Nagar Society, Tulsidham, Thane West, Maharashtra 400606, India",
  email: "hello@malansh.in",
  phone: "+91 97696 25725",
  phoneHref: "tel:+919769625725",
  linkedin: "https://www.linkedin.com/company/malansh-solutions-private-limited/",
  cin: "CIN: U74109MH2025PTC446319",
};


